<template>
  <div class="container">
    <vue-particles
      id="tsparticles"
      :particlesInit="particlesInit"
      :particlesLoaded="particlesLoaded"
      :options="nasaParticle"
    />

    <Card class="login-card">
      <template #header>
        <img
          class="logo"
          height="30"
          width="30"
          :src="logo"
          alt="Autogestión"
        />
      </template>

      <template #title>
        <h2>Actualizar contraseña</h2>
      </template>

      <template #subtitle> Actualiza la contraseña temporal </template>

      <template #content class="padding-2">
        <form
          id="login-form"
          autocomplete="new-password"
          @submit.prevent="update"
        >
          <label>Contraseña nueva<span>*</span></label>
          <Password
            v-model="password"
            type="password"
            :feedback="false"
            toggleMask
            :pt="{
              input: {
                class: 'w-12',
              },
              panel: {
                class: 'hidden',
              },
            }"
          />
          <span class="error-message">
            {{ passwordError }}
          </span>
          <br />

          <label>Confirmar contraseña nueva<span>*</span></label>
          <Password
            v-model="confirmPassword"
            autocomplete="new-password"
            type="password"
            :feedback="false"
            toggleMask
            :pt="{
              input: {
                class: 'w-12',
              },
              panel: {
                class: 'hidden',
              },
            }"
          />
          <span class="error-message">
            {{ confirmError }}
          </span>
          <br />

          <Button
            type="submit"
            :class="isLoading ? 'p-disabled loading' : ''"
            :disabled="!isValidToUptade"
          >
            <span v-if="isLoading">
              <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
            </span>
            <span v-else>Actualizar</span>
          </Button>
        </form>
      </template>
    </Card>
  </div>
</template>
<script setup lang="ts">
  import { loadSlim } from 'tsparticles-slim'
  import { computed, ref } from 'vue'
  import { onMounted } from 'vue'
  import { useField } from 'vee-validate'
  import * as yup from 'yup'
  import logo from '../../../assets/logo_new_res.png'
  import { useUserStore } from '@/store/user'
  import { useRoute, useRouter } from 'vue-router'
  import useNotifications from '@/store/notification'
  import { nasaParticle } from '@/assets/particles/nasa'

  const notificationStore = useNotifications()

  const emailSchema = yup
    .string()
    .required('El correo es requerido')
    .email('Ingrese un correo válido')

  const passwordSchema = yup
    .string()
    .required('La contraseña es requerida')
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .test(
      'password-complexity',
      'La contraseña debe contener al menos una letra mayúscula y un número',
      (value) => {
        // La expresión regular para validar al menos una letra mayúscula y un número
        const regex = /^(?=.*[A-Z])(?=.*\d)/
        return regex.test(value)
      }
    )

  const confirmPasswordSchema = yup
    .string()
    .required('La confirmación de la contraseña es requerida')
    .test(
      'passwords-match',
      'Las contraseñas deben coincidir',
      function (value) {
        return value === password.value
      }
    )
    .min(8, 'La contraseña debe tener al menos 8 caracteres')

  //forms validation
  const {
    value: email,
    errorMessage: emailError,
    validate: emailValidate,
  } = useField<string>('email', emailSchema)
  const {
    value: password,
    errorMessage: passwordError,
    validate: passwordValidate,
  } = useField<string>('password', passwordSchema)
  const {
    value: confirmPassword,
    errorMessage: confirmError,
    validate: confirmPassValidate,
  } = useField<string>('confirmPassword', confirmPasswordSchema)

  const router = useRouter()
  const store = useUserStore()
  const isLoading = ref(false)
  const isSubmitted = ref(false)

  onMounted(() => {
    const emailLogged: string = localStorage.getItem('email') || ''
    if (!emailLogged) {
      router.push('/login')
    }

    email.value = emailLogged
  })

  const update = async () => {
    if (password.value === confirmPassword.value) {
      isSubmitted.value = true
      isLoading.value = true
      const response = await store.updateTemporaryPassword(
        email.value,
        password.value
      )
      isLoading.value = false

      if (response) {
        notificationStore.addSuccesNotification({
          detail: `200`,
          severity: 'success',
          summary: `¡Contraseña actualizada con éxito!`,
        })
        router.push('/login')
      } else {
        router.push('/login')
      }
    }
  }

  const isValidToUptade = computed(
    () => email.value && confirmPassword.value === password.value
  )

  const particlesInit = async (engine: any) => {
    //await loadFull(engine);
    await loadSlim(engine)
  }

  const particlesLoaded = async (container: any) => {}
</script>

<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    height: auto;
    background-color: #f8f9fa;
    /* background-image: url('../../../assets/LinePattern_login.svg'); */
  }

  .login-card {
    width: 25em;
    min-height: 4rem;
    padding: 2rem;
    z-index: 9;
  }

  .logo {
    width: 100%;
    object-fit: contain;
    height: 80px;
  }

  #login-form {
    display: flex;
    flex-flow: column wrap;
    text-align: left;
  }

  Button {
    display: block;
  }

  label {
    padding-bottom: 5px;
  }

  .error-message {
    padding-top: 5px;
    color: rgb(234, 68, 68);
    font-size: 12px;
  }
</style>
